export enum TaskVariableType {
    EvaluatorRemark = 'EvaluatorRemark',
    EvaluationHistory = 'EvaluationHistory'
}
